import { classifyError, ErrorType, getUserFriendlyMessage } from "./errorUtils";

const DEFAULT_CONTEXT_MESSAGES = {
  buyer_review_tasks:
    "Could not load buyer review tasks. Try again or contact an administrator.",
  menu_gap_tasks: "Could not load menu gap tasks. Try again or contact an administrator.",
  inventory_cleanup_tasks:
    "Could not load inventory cleanup tasks. Try again or contact an administrator.",
  stale_inventory_tasks:
    "Could not load stale inventory tasks. Try again or contact an administrator.",
  deal_workflow_drafts:
    "Could not load deal poster drafts. Try again or contact an administrator.",
};

function resolveDefaultMessage(context) {
  if (context && DEFAULT_CONTEXT_MESSAGES[context]) {
    return DEFAULT_CONTEXT_MESSAGES[context];
  }
  return "Could not load tasks. Try again or contact an administrator.";
}

/**
 * Format Firestore task-queue load failures for hook consumers and tests.
 */
export function toTaskQueueLoadDisplayError(error, { context } = {}) {
  if (!error) {
    return error;
  }

  const defaultMessage = resolveDefaultMessage(context);
  const friendly = getUserFriendlyMessage(error, defaultMessage);
  const displayMessage =
    classifyError(error) === ErrorType.UNKNOWN ? defaultMessage : friendly;
  const displayError = new Error(displayMessage);
  if (error?.code) {
    displayError.code = error.code;
  }
  displayError.originalError = error;
  return displayError;
}
